import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import * as lodash from 'lodash'
import { getCurrenciesWithFlagIcon } from '../../constants'
import { Destroyable } from '../../rx-operators'

@Component({
  selector: 'app-currency-select',
  templateUrl: './currency-select.component.html',
  styleUrls: ['./currency-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CurrencySelectComponent extends Destroyable implements OnInit {
  currencies = getCurrenciesWithFlagIcon()

  @Input() ctrl: UntypedFormControl

  @Input() inline = false
  @Input() compareWith = (o1: any, o2: any) => (lodash.isObjectLike(o1) ? o1?.code === o2?.code : o1 === o2)
  @Input() bindValue = (c: any) => c

  @Input() label = $localize`Currency`

  ngOnInit(): void {}
}
